{
  "ACTIVITY": "https://activity.v2.iesdev.com",
  "ACTIVITY_MEDIA": "media://activity.media.com",
  "ACHIEVEMENTS": "https://achievements.v2.iesdev.com",
  "ANALYTICS": "https://analytics.iesdev.com",
  "APEX": "https://apex.v2.iesdev.com",
  "AUTH": "https://auth.blitz.gg",
  "AUTH_GRAPHQL": "https://auth.blitz.gg/graphql",
  "AUTH_WS_URL": "wss://auth.blitz.gg",
  "BATTLES": "https://competitions.iesdev.com",
  "BATTLES_CDN": "https://blitz-cms-iesdev.blitz.gg/challenge_assets",
  "BLITZ_STABLE_MAC": "https://blitz-main.blitz.gg/latest-mac.yml",
  "BLITZ_STABLE_WINDOWS": "https://blitz-main.blitz.gg/latest.yml",
  "BLITZ": "https://blitz.gg",
  "CDN_PLAIN": "https://blitz-cdn-plain.blitz.gg",
  "CDN_VIDEOS": "https://blitz-cdn-videos.blitz.gg",
  "CDN_WEB": "https://blitz-cdn-web.blitz.gg",
  "CDN": "https://blitz-cdn.blitz.gg",
  "CMS": "https://cms-api.v2.iesdev.com",
  "CSGO_V2": "https://cs2.v2.iesdev.com",
  "DEADLOCK": "https://deadlock.iesdev.com",
  "EFT": "https://tarkov.v2.iesdev.com",
  "FEEDBACK": "https://feedback.iesdev.com",
  "FORTNITE": "https://fortnite.v2.iesdev.com",
  "KRYPTONITE_API_URL": "https://kryptonite.iesdev.com",
  "LOL_LEAGUE_PLAYER": "https://league-player.iesdev.com",
  "LOL": "https://lol.v2.iesdev.com",
  "PAYMENTS": "https://payments.v2.iesdev.com",
  "PROBUILDS_URL": "https://probuilds.iesdev.com",
  "REALTIME": "wss://rt.blitz.gg",
  "RIOT": "https://riot.iesdev.com",
  "ROCKET": "https://rocket-league-server.iesdev.com",
  "SEARCH": "https://search.v2.iesdev.com",
  "SEARCH_V2": "https://search-v2.iesdev.com",
  "SOLOMID_RESOURCE_URL": "https://solomid-resources.blitz.gg",
  "TFT_V3": "https://tft.iesdev.com",
  "TFT": "https://tft-server.iesdev.com",
  "TFT_DEPRECATED_AGGREGATE": "https://tft-aggr.iesdev.com",
  "TFT_DEPRECATED_GRAPHQL": "https://tft.iesdev.com/graphql",
  "TFT_DEPRECATED": "https://tft.iesdev.com",
  "TRACK_EVENTS": "https://science.v2.iesdev.com/append",
  "TWITTER_SHARE": "https://twitter.com/intent/tweet",
  "UTILS_STATIC": "https://utils.iesdev.com/static/json",
  "UTILS": "https://utils.iesdev.com",
  "VALORANT": "https://valorant.v2.iesdev.com",
  "VALORANT_V2": "https://valorant.v2.iesdev.com",
  "RIOT_RSO": "https://auth.riotgames.com/authorize?client_id=theblitzapp&redirect_uri=https://blitz.gg/riot-oauth/callback&response_type=code&scope=openid+offline_access",
  "DATALAKE": "https://datalake.v2.iesdev.com",
  "MSI": "https://msi.com",
  "CONTENTFUL_ASSET_ORIGIN": "https://images.ctfassets.net",
  "CONTENTFUL_ASSET_CDN": "https://contentful-images.blitz.gg",
  "CONTENTFUL_ASSET_VID_ORIGIN": "https://videos.ctfassets.net",
  "CONTENTFUL_ASSET_VID_CDN": "https://contentful-videos.blitz.gg",
  "CONTENTFUL_GQL_ORIGIN": "https://graphql.contentful.com",
  "CONTENTFUL_GQL_BLITZ": "https://contentful.blitz.gg",
  "MARVEL_RIVALS": "https://rivals.v2.iesdev.com/rivals"
}